const n = "_container_1wbv2_1", e = "_large_1wbv2_23", _ = "_handle_1wbv2_33", r = "_circle_1wbv2_47", c = "_line_1wbv2_63", t = "_error_1wbv2_127", o = "_input_1wbv2_141", l = {
  container: n,
  large: e,
  handle: _,
  circle: r,
  line: c,
  error: t,
  input: o
};
export {
  r as circle,
  n as container,
  l as default,
  t as error,
  _ as handle,
  o as input,
  e as large,
  c as line
};
//# sourceMappingURL=Switch.module.css.js.map
